import { render, staticRenderFns } from "./Step2-1.vue?vue&type=template&id=7da15e73&scoped=true&"
import script from "./Step2-1.vue?vue&type=script&lang=ts&"
export * from "./Step2-1.vue?vue&type=script&lang=ts&"
import style0 from "./Step2-1.vue?vue&type=style&index=0&id=7da15e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da15e73",
  null
  
)

export default component.exports